import { render, staticRenderFns } from "./FundingCard.vue?vue&type=template&id=72510d22&scoped=true&"
import script from "./FundingCard.vue?vue&type=script&lang=js&"
export * from "./FundingCard.vue?vue&type=script&lang=js&"
import style0 from "./FundingCard.vue?vue&type=style&index=0&id=72510d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72510d22",
  null
  
)

export default component.exports